import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RouterModule } from '@angular/router';
import { mat } from '../../../../../shared';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { SeItem } from 'libs/shared/src/lib/shared/core/data/type';



@Component({
  selector: 'lib-basic-menu',
  templateUrl: './basic-menu.component.html',
  styleUrls: ['./basic-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    mat,
    RouterModule
  ]
})
export class BasicMenuComponent implements OnChanges {
  @Input() hide = false
  @Input() Isicon = true
  @Input() item: SeItem | null = null
  role: any
  constructor() {
    const keyToken: string = localStorage.getItem("token") as string
    this.role = JSON.parse(keyToken).role
  }


  ngOnChanges(changes: SimpleChanges): void {
    if ('item' in changes) {
      // console.log(this.item)
    }
  }


  hasRole(userRole: string | string[]): boolean {
    // console.log(userRole)
    const userRolesArray = Array.isArray(userRole) ? userRole : [userRole];
    // console.log(userRolesArray)
    return userRolesArray.some((r:any) => this.item?.role?.includes(r));
  }


}
